import CareUnitsRepository from "@/repositories/CareUnitsRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'coreunits',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await CareUnitsRepository.fetch(id).then(response => {
                commit('setCurrent', response.data)
            })
            commit('setLoading', false)
        },
        async listAllPaginated ({commit}, params) {
            commit('setLoading', true)
            await CareUnitsRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', response.data)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await CareUnitsRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', response.data)
            })
            commit('setLoading', false)
        },
        async search ({ commit, state, rootState }, params) {
            commit('setLoading', true)
            await CareUnitsRepository.fetchAll(params).then(response => {
                if (response.data.data.length > 0){
                    const array = response.data.data
                    commit('setAll', Object.values([...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }else{
                    commit('setAll', Object.values([]));
                }
            })

            commit('setLoading', false)
        }
    }
}
